<template>
    <div class="svg-icon"
         :style="{
        'stroke': color,
        'fill': fill,
    }"
         :class="[this.class]">

        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 488.3 488.3"

             stroke-width="2"
             stroke-linecap="round"
             stroke-linejoin="round"
             v-if="icon === 'copy'"
             :class="[this.class]"
             :color="color"
             :fill="color"
             :stroke="color"
        >

            <path d="M314.25,85.4h-227c-21.3,0-38.6,17.3-38.6,38.6v325.7c0,21.3,17.3,38.6,38.6,38.6h227c21.3,0,38.6-17.3,38.6-38.6V124
			C352.75,102.7,335.45,85.4,314.25,85.4z M325.75,449.6c0,6.4-5.2,11.6-11.6,11.6h-227c-6.4,0-11.6-5.2-11.6-11.6V124
			c0-6.4,5.2-11.6,11.6-11.6h227c6.4,0,11.6,5.2,11.6,11.6V449.6z"/>
            <path d="M401.05,0h-227c-21.3,0-38.6,17.3-38.6,38.6c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5c0-6.4,5.2-11.6,11.6-11.6h227
			c6.4,0,11.6,5.2,11.6,11.6v325.7c0,6.4-5.2,11.6-11.6,11.6c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5c21.3,0,38.6-17.3,38.6-38.6
			V38.6C439.65,17.3,422.35,0,401.05,0z"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="svg-icon feather feather-grid"
             v-if="icon === 'board'">
            <rect x="3" y="3" width="7" height="7"></rect>
            <rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect>
            <rect x="3" y="14" width="7" height="7"></rect>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="mr-50 feather feather-user" :class="[this.class]"
             v-if="icon === 'user'">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="mr-50 feather feather-lock" :class="[this.class]"
             v-if="icon === 'lock'">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="feather feather-power me-50" :class="[this.class]"
             v-if="icon === 'logout'">
            <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
            <line x1="12" y1="2" x2="12" y2="12"></line>
        </svg>


        <svg v-if="icon === 'event'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
             class="bi bi-calendar4-event" viewBox="0 0 16 16">
            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"/>
            <path d="M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
        </svg>
        <svg v-if="icon === 'location'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
             class="bi bi-geo-alt" viewBox="0 0 16 16">
            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/>
            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
        </svg>
        <svg v-if="icon === 'calendar'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
             viewBox="0 0 20 20">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5.89935 2C6.31356 2 6.64935 2.33579 6.64935 2.75V3.25391H9.25V2.75C9.25 2.33579 9.58579 2 10 2C10.4142 2 10.75 2.33579 10.75 2.75V3.25391H13.25V2.75C13.25 2.33579 13.5858 2 14 2C14.4142 2 14.75 2.33579 14.75 2.75V3.25391H15.25C16.7688 3.25391 18 4.48512 18 6.00391V9.09766C18 9.51187 17.6642 9.84766 17.25 9.84766C16.8358 9.84766 16.5 9.51187 16.5 9.09766V6.00391C16.5 5.31355 15.9404 4.75391 15.25 4.75391H14.75V5.2514C14.75 5.66561 14.4142 6.0014 14 6.0014C13.5858 6.0014 13.25 5.66561 13.25 5.2514V4.75391H10.75V5.2514C10.75 5.66561 10.4142 6.0014 10 6.0014C9.58579 6.0014 9.25 5.66561 9.25 5.2514V4.75391H6.64935V5.2514C6.64935 5.66561 6.31356 6.0014 5.89935 6.0014C5.48513 6.0014 5.14935 5.66561 5.14935 5.2514V4.75391H4.75C4.05964 4.75391 3.5 5.31355 3.5 6.00391V15.2539C3.5 15.9443 4.05964 16.5039 4.75 16.5039H9.09375C9.50796 16.5039 9.84375 16.8397 9.84375 17.2539C9.84375 17.6681 9.50796 18.0039 9.09375 18.0039H4.75C3.23122 18.0039 2 16.7727 2 15.2539V6.00391C2 4.48512 3.23122 3.25391 4.75 3.25391H5.14935V2.75C5.14935 2.33579 5.48513 2 5.89935 2ZM6.62 8.5539C6.62 8.9405 6.3066 9.2539 5.92 9.2539C5.5334 9.2539 5.22 8.9405 5.22 8.5539C5.22 8.16731 5.5334 7.8539 5.92 7.8539C6.3066 7.8539 6.62 8.16731 6.62 8.5539ZM8.62 9.2539C9.0066 9.2539 9.32 8.9405 9.32 8.5539C9.32 8.16731 9.0066 7.8539 8.62 7.8539C8.2334 7.8539 7.92 8.16731 7.92 8.5539C7.92 8.9405 8.2334 9.2539 8.62 9.2539ZM6.62 11.2839C6.62 11.6705 6.3066 11.9839 5.92 11.9839C5.5334 11.9839 5.22 11.6705 5.22 11.2839C5.22 10.8973 5.5334 10.5839 5.92 10.5839C6.3066 10.5839 6.62 10.8973 6.62 11.2839ZM8.62 11.9839C9.0066 11.9839 9.32 11.6705 9.32 11.2839C9.32 10.8973 9.0066 10.5839 8.62 10.5839C8.2334 10.5839 7.92 10.8973 7.92 11.2839C7.92 11.6705 8.2334 11.9839 8.62 11.9839ZM6.62 13.9939C6.62 14.3805 6.3066 14.6939 5.92 14.6939C5.5334 14.6939 5.22 14.3805 5.22 13.9939C5.22 13.6073 5.5334 13.2939 5.92 13.2939C6.3066 13.2939 6.62 13.6073 6.62 13.9939ZM8.62 14.6939C9.0066 14.6939 9.32 14.3805 9.32 13.9939C9.32 13.6073 9.0066 13.2939 8.62 13.2939C8.2334 13.2939 7.92 13.6073 7.92 13.9939C7.92 14.3805 8.2334 14.6939 8.62 14.6939ZM12.05 8.5539C12.05 8.9405 11.7366 9.2539 11.35 9.2539C10.9634 9.2539 10.65 8.9405 10.65 8.5539C10.65 8.16731 10.9634 7.8539 11.35 7.8539C11.7366 7.8539 12.05 8.16731 12.05 8.5539ZM14.05 9.2539C14.4366 9.2539 14.75 8.9405 14.75 8.5539C14.75 8.16731 14.4366 7.8539 14.05 7.8539C13.6634 7.8539 13.35 8.16731 13.35 8.5539C13.35 8.9405 13.6634 9.2539 14.05 9.2539Z"
                  fill="#3F434A"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M16.5 14.0039C16.5 15.3846 15.3807 16.5039 14 16.5039C12.6193 16.5039 11.5 15.3846 11.5 14.0039C11.5 12.6232 12.6193 11.5039 14 11.5039C15.3807 11.5039 16.5 12.6232 16.5 14.0039ZM18 14.0039C18 16.213 16.2091 18.0039 14 18.0039C11.7909 18.0039 10 16.213 10 14.0039C10 11.7948 11.7909 10.0039 14 10.0039C16.2091 10.0039 18 11.7948 18 14.0039ZM14.2 13.0039C14.2 12.7278 13.9761 12.5039 13.7 12.5039C13.4239 12.5039 13.2 12.7278 13.2 13.0039V14.5039C13.2 14.78 13.4239 15.0039 13.7 15.0039H14.9C15.1761 15.0039 15.4 14.78 15.4 14.5039C15.4 14.2278 15.1761 14.0039 14.9 14.0039H14.2V13.0039Z"
                  fill="#3F434A"/>
        </svg>
        <svg v-if="icon === 'x' || icon === 'close'" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             fill="currentColor" viewBox="0 0 24 24">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
        <svg v-if="icon === 'v' || icon === 'check'" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             fill="none" viewBox="0 0 24 24" stroke-linecap="round">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <svg v-if="icon === 'fav' || icon === 'heart'" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             fill="currentColor" viewBox="0 0 24 24">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
        <svg v-if="icon === 'pencil' || icon === 'edit'" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             fill="none" viewBox="0 0 24 24">
            <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
        </svg>
        <svg v-if="icon === 'trash' || icon === 'delete'" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             fill="none" viewBox="0 0 24 24">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        </svg>
        <svg v-if="icon === 'plus'" width="20" height="20" viewBox="0 0 20 20" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V9H5C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11H9V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9H11V5Z"
                  fill="#3F434A"/>

        </svg>

        <svg v-if="icon === 'folder'" xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120"
             fill="none">
            <path d="M97 25H23V56H97V25Z" fill="#F2F4F5"/>
            <path d="M108 94.8C108 97.3461 106.989 99.7879 105.188 101.588C103.388 103.389 100.946 104.4 98.4 104.4H21.6C19.0539 104.4 16.6121 103.389 14.8118 101.588C13.0114 99.7879 12 97.3461 12 94.8V27.6C12 25.0539 13.0114 22.6121 14.8118 20.8118C16.6121 19.0114 19.0539 18 21.6 18H45.6L55.2 32.4H98.4C100.946 32.4 103.388 33.4114 105.188 35.2118C106.989 37.0121 108 39.4539 108 42V94.8Z"
                  fill="#FCD297"/>
        </svg>


        <svg v-if="icon === 'ring'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="feather feather-disc d-none d-xl-block collapse-toggle-icon primary font-medium-4">
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="3"></circle>
        </svg>
        <svg v-if="icon === 'search'" width="18" height="18" viewBox="0 0 21 21" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.75 9C3.75 6.1005 6.1005 3.75 9 3.75C11.8995 3.75 14.25 6.1005 14.25 9C14.25 11.8995 11.8995 14.25 9 14.25C6.1005 14.25 3.75 11.8995 3.75 9ZM9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C10.5938 15.75 12.0585 15.1976 13.2133 14.2739L16.7192 17.7799C17.0121 18.0728 17.487 18.0728 17.7799 17.7799C18.0728 17.487 18.0728 17.0121 17.7799 16.7192L14.2739 13.2133C15.1976 12.0585 15.75 10.5938 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25Z"
                  fill="#8A9099"/>
        </svg>

        <svg v-if="icon === 'refresh'" :fill="fill" height="16" width="16" viewBox="0 0 489.645 489.645">
            <g>
                <path d="M460.656,132.911c-58.7-122.1-212.2-166.5-331.8-104.1c-9.4,5.2-13.5,16.6-8.3,27c5.2,9.4,16.6,13.5,27,8.3
		c99.9-52,227.4-14.9,276.7,86.3c65.4,134.3-19,236.7-87.4,274.6c-93.1,51.7-211.2,17.4-267.6-70.7l69.3,14.5
		c10.4,2.1,21.8-4.2,23.9-15.6c2.1-10.4-4.2-21.8-15.6-23.9l-122.8-25c-20.6-2-25,16.6-23.9,22.9l15.6,123.8
		c1,10.4,9.4,17.7,19.8,17.7c12.8,0,20.8-12.5,19.8-23.9l-6-50.5c57.4,70.8,170.3,131.2,307.4,68.2
		C414.856,432.511,548.256,314.811,460.656,132.911z"/>
            </g>
        </svg>

        <svg v-if="icon === 'cog'" :fill="fill" :height="height" :width="width" viewBox="0 -256 1792 1792">
            <g
            >
                <path
                        d="m 1024,640 q 0,106 -75,181 -75,75 -181,75 -106,0 -181,-75 -75,-75 -75,-181 0,-106 75,-181 75,-75 181,-75 106,0 181,75 75,75 75,181 z m 512,109 V 527 q 0,-12 -8,-23 -8,-11 -20,-13 l -185,-28 q -19,-54 -39,-91 35,-50 107,-138 10,-12 10,-25 0,-13 -9,-23 -27,-37 -99,-108 -72,-71 -94,-71 -12,0 -26,9 l -138,108 q -44,-23 -91,-38 -16,-136 -29,-186 -7,-28 -36,-28 H 657 q -14,0 -24.5,8.5 Q 622,-111 621,-98 L 593,86 q -49,16 -90,37 L 362,16 Q 352,7 337,7 323,7 312,18 186,132 147,186 q -7,10 -7,23 0,12 8,23 15,21 51,66.5 36,45.5 54,70.5 -27,50 -41,99 L 29,495 Q 16,497 8,507.5 0,518 0,531 v 222 q 0,12 8,23 8,11 19,13 l 186,28 q 14,46 39,92 -40,57 -107,138 -10,12 -10,24 0,10 9,23 26,36 98.5,107.5 72.5,71.5 94.5,71.5 13,0 26,-10 l 138,-107 q 44,23 91,38 16,136 29,186 7,28 36,28 h 222 q 14,0 24.5,-8.5 Q 914,1391 915,1378 l 28,-184 q 49,-16 90,-37 l 142,107 q 9,9 24,9 13,0 25,-10 129,-119 165,-170 7,-8 7,-22 0,-12 -8,-23 -15,-21 -51,-66.5 -36,-45.5 -54,-70.5 26,-50 41,-98 l 183,-28 q 13,-2 21,-12.5 8,-10.5 8,-23.5 z"
                />
            </g>
        </svg>


        <svg v-if="icon === 'arrow-left'" xmlns="http://www.w3.org/2000/svg" stroke-width=".2"  :width="width" :height="height" :fill="fill" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
        </svg>

        <svg v-if="icon === 'divide-column'" xmlns="http://www.w3.org/2000/svg" stroke-width=".2" :width="width" :height="height" :fill="fill" class="bi bi-hr" viewBox="0 0 16 16">
            <path d="M12 3H4a1 1 0 0 0-1 1v2.5H2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2.5h-1V4a1 1 0 0 0-1-1zM2 9.5h1V12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V9.5h1V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5zm-1.5-2a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"/>
        </svg>

        <svg v-if="icon === 'divide-row'" xmlns="http://www.w3.org/2000/svg" stroke-width=".2" :width="width" :height="height" :fill="fill" class="bi bi-vr" viewBox="0 0 16 16">
            <path d="M3 12V4a1 1 0 0 1 1-1h2.5V2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5v-1H4a1 1 0 0 1-1-1zm6.5 1v1H12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H9.5v1H12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9.5zM8 16a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5z"/>
        </svg>

        <svg v-if="icon === 'new-section'" xmlns="http://www.w3.org/2000/svg" stroke-width=".2" :width="width" :height="height" :fill="fill" class="bi bi-plus-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        </svg>

        <svg v-if="icon === 'delete-section'" xmlns="http://www.w3.org/2000/svg" stroke-width=".2" :width="width" :height="height" :fill="fill" class="bi bi-trash" viewBox="0 0 16 16">
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
        </svg>

        <svg v-if="icon === 'fill-section'" xmlns="http://www.w3.org/2000/svg" stroke-width=".2" :width="width" :height="height" :fill="fill" class="bi bi-pen" viewBox="0 0 16 16">
            <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
        </svg>

    </div>
</template>

<script>
export default {
    name: "ShowSvg",
    props: {
        icon: {},
        color: {
            default() {
                return 'rgba(110,107,123)';
            }
        },
        fill: {
            default() {
                return 'rgba(110,107,123)';
            }
        },
        height: {
            default() {
                return '16';
            }
        },
        width: {
            default() {
                return '16';
            }
        },
        class: {}
    }
}
</script>

<style scoped lang="scss">
.svg-icon {

  display: inline-block;
  color: inherit;

  & svg {
    stroke: inherit;
  }
}
</style>